import React from "react";
import { fetchItemAuditLogs } from "../../../services/dashboardServices";
import WithAuditLogs from "./WithAuditLogs";

const ItemAuditLogs = ({ itemId, itemTitle, onClose }) => (
  <WithAuditLogs
    id={itemId}
    title={`Audit Logs for item: ${itemTitle}`}
    fetchFn={fetchItemAuditLogs}
    onClose={onClose}
  />
);

export default ItemAuditLogs;
